
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import { useGetuser } from "./useGetuser";

import { setgtMessage } from "../../redux/gtmsgSlice";
import { gtNeutral } from "../../redux/gtstatusSlice";


export const useAppuserout = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const user = useSelector((state) => state.user.value)
    const { getUser } = useGetuser()

    const checkAppUser = async () => {
        try {
            var storeditem = localStorage.getItem('onixwalletaddress')
            if(!storeditem) {
                // navigate('/auth')
                console.log('wallet is not connected')
                dispatch(gtNeutral())
                dispatch(setgtMessage("connect wallet to get the most of features"))
            } else {
                // check if user is null then make request to the db to get details
                if(!user) {
                    console.log('user state is null')
                    var parsed = JSON.parse(storeditem)
                    await getUser(parsed.walletaddress)
                }
            }
        } catch(err) {
            console.log(err)
        }
    }


    return { checkAppUser }

}







